var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00292969 6.38143C0.00292969 2.85706 2.85999 0 6.38436 0H51.3442C54.8686 0 57.7256 2.85706 57.7256 6.38143V51.3635C57.7256 54.8879 54.8686 57.7449 51.3442 57.7449H6.38437C2.86 57.7449 0.00292969 54.8879 0.00292969 51.3635V6.38143Z",
    fill: "url(#paint0_linear_755_38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2849 64.022H20.6584C18.6064 64.022 16.9434 62.3582 16.9434 60.3055C16.9434 36.3594 36.348 16.9473 60.2849 16.9473C62.3368 16.9473 63.9999 18.611 63.9999 20.6637V60.3055C63.9999 62.3582 62.3368 64.022 60.2849 64.022Z",
    fill: "url(#paint1_linear_755_38)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0139 38.0149L44.3217 57.1592H39.2739L41.9474 38.0149H47.0139ZM48.0048 31.1162L47.2383 36.4071H42.1904L42.957 31.1162H48.0048Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1138 11.9003C26.2362 11.9003 25.1873 13.7649 25.6146 15.1505L21.0177 19.7603C20.6293 19.6438 20.0595 19.6438 19.6711 19.7603L16.3691 16.4583C16.8093 15.0728 15.7605 13.1952 13.8699 13.1952C11.9923 13.1952 10.9305 15.0598 11.3708 16.4583L5.46602 22.3501C4.08047 21.9228 2.21582 22.9717 2.21582 24.8493C2.21582 26.2737 3.38123 27.4391 4.80562 27.4391C6.68322 27.4391 7.73209 25.5744 7.30477 24.1889L13.1966 18.2841C13.585 18.4007 14.1548 18.4007 14.5433 18.2841L17.8452 21.5861C17.405 22.9717 18.4538 24.8493 20.3444 24.8493C22.222 24.8493 23.2838 22.9846 22.8436 21.5861L27.4534 16.9892C28.8389 17.4165 30.7036 16.3677 30.7036 14.4901C30.7036 13.0657 29.5382 11.9003 28.1138 11.9003Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3444 13.1952L21.5616 10.5147L24.2291 9.31048L21.5616 8.10622L20.3444 5.42578L19.1531 8.10622L16.4597 9.31048L19.1531 10.5147L20.3444 13.1952Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45307 15.785L6.10052 13.1952L8.69031 12.5477L6.10052 11.9003L5.45307 9.31048L4.80562 11.9003L2.21582 12.5477L4.80562 13.1952L5.45307 15.785Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_38",
    x1: 28.8643,
    y1: 57.7449,
    x2: 28.8643,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1442,
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A3A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_755_38",
    x1: 62.9118,
    y1: 62.9334,
    x2: 29.625,
    y2: 29.6594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33AFE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightIcon);
export default __webpack_public_path__ + "static/media/insight-icon.389288cbbde0747ad736ddbcdfe51ddc.svg";
export { ForwardRef as ReactComponent };